import React from "react";
import { BlockStack, Card, SkeletonBodyText, SkeletonDisplayText } from "@shopify/polaris";

export function HomeSkeletonCard(): React.JSX.Element {
  return (
    <Card>
      <BlockStack gap="400">
        <SkeletonDisplayText size="small" />
        <SkeletonBodyText lines={10} />
      </BlockStack>
    </Card>
  );
}
